import { RegisterForm } from '@/features/auth/components/register-form';

export const RegisterPage = () => {
  return <RegisterForm />;
};
